var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.99988,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7.54523,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12.0907,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 4.27274,
    y: 5.24219,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 4.27274,
    y: 9.81793,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 4.27274,
    y: 14.3634,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 6.54544,
    y: 2.99976,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 6.54544,
    y: 7.54523,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 6.54544,
    y: 12.0907,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 8.81818,
    y: 5.24219,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 8.81818,
    y: 9.81793,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 8.81818,
    y: 14.3634,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    x: 11.0909,
    y: 2.99976,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    x: 11.0909,
    y: 7.54523,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    x: 11.0909,
    y: 12.0907,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.3636,
    y: 5.24219,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.3636,
    y: 9.81793,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.3636,
    y: 14.3634,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 15.6364,
    y: 2.99976,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 15.6364,
    y: 7.54523,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 15.6364,
    y: 12.0907,
    width: 2.36364,
    height: 2.36364,
    rx: 0.484848,
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpacity);
export default __webpack_public_path__ + "static/media/opacity.a37d66ac953c4732f8f05feddf61197e.svg";
export { ForwardRef as ReactComponent };